export default __webpack_public_path__ + "static/media/logo.684bcee6.png";